import { RouterModule } from "@angular/router";
import { NgModule, Component } from "@angular/core";

import { AppNotfoundComponent } from "./air/pages/notfound/app.notfound.component";
import { AppErrorComponent } from "./air/pages/error/app.error.component";
import { AppAccessdeniedComponent } from "./air/pages/access/app.accessdenied.component";

import { AppMaintenanceComponent } from "./air/pages/maintain/app.maintenance";
import { AppEndUserLicenseAgreementComponent } from "./air/pages/end-user-license-agreement/app.end-user-license-agreement.component";
import { ForgetPasswordComponent } from "./air/pages/auth/forget-password/forget-password.component";
import { PasswordConfirmComponent } from "./air/pages/auth/password-confirm/password-confirm.component";
import { ResendComponent } from "./air/pages/auth/resend/resend.component";
import { ResetPasswordComponent } from "./air/pages/auth/reset-password/reset-password.component";
import { ResetPasswordAuthComponent } from "./air/pages/auth/reset-password-auth/reset-password-auth.component";
import { AuthGuard } from "../../src/app/air/modules/common/guards/auth/auth.guard";
import { NoAuthGuard } from "../../src/app/air/modules/common/guards/noAuth/no-auth.guard";
import { AccessGuard } from "../../src/app/air/modules/common/guards/access/access.guard";

import { AppAssociationComponent } from './air/pages/association/app.association.component';

import { AirAppRoutes } from './air/modules/common/lib/air-api-constant';
import { AppLoginComponent } from "./air/pages/auth/login/app.login.component";
import { AppMainComponent } from "./air/modules/common/component";
import { DirectLinkShipmentTrackingDetailsComponent } from "./direct-link/direct-link-shipment-tracking-details/direct-link-shipment-tracking-details.component";
import { DirectLinkComponent } from "./direct-link/direct-link.component";
@NgModule({
    imports: [
        RouterModule.forRoot([

            // {
            //     path: '',
            //     redirectTo: AirAppRoutes.Auth.LOGIN,
            //     pathMatch: 'full',

            // },
            // {
            //     path: 'login',
            //     component: AppLoginComponent,
            //     canActivate: [NoAuthGuard]
            // },
            {
                path: '',
                redirectTo: `${AirAppRoutes.User.ROOT}/${AirAppRoutes.User.HOME}`,
                pathMatch: 'full',
            },
            {
                path: AirAppRoutes.User.ROOT,
                component: AppMainComponent,
                canActivate: [AuthGuard, AccessGuard],
                children: [
                    {
                        path: AirAppRoutes.User.ROOT_AIR,
                        loadChildren: () => import('./air/air.module').then(m => m.AirModule)
                    },

                    {
                        path: AirAppRoutes.User.MAINTENANCE,
                        component: AppMaintenanceComponent
                    },
                    {
                        path: AirAppRoutes.User.NOT_ASSOCIATED,
                        component: AppAssociationComponent,
                    }
                ]
            },
            { path: AirAppRoutes.Auth.LOGOUT, component: AppLoginComponent, canActivate: [AuthGuard] },
            { path: AirAppRoutes.Auth.EULA, component: AppEndUserLicenseAgreementComponent },
            { path: AirAppRoutes.Auth.RESET_PASSWORD, component: ResetPasswordComponent, canActivate: [NoAuthGuard] },
            { path: AirAppRoutes.Auth.RESET_PASSWORD_AUTH, component: ResetPasswordAuthComponent, canActivate: [NoAuthGuard] },
            { path: AirAppRoutes.Auth.FORGET_PASSWORD, component: ForgetPasswordComponent, canActivate: [NoAuthGuard] },
            { path: AirAppRoutes.Auth.RESEND_LINK, component: ResendComponent, canActivate: [NoAuthGuard] },
          //  { path: AirAppRoutes.Auth.REGISTER, component: RegisterComponent, canActivate: [NoAuthGuard] },
            { path: AirAppRoutes.Auth.PASSWORD_CONFIRM, component: PasswordConfirmComponent, canActivate: [NoAuthGuard] },
            { path: AirAppRoutes.Auth.ERROR, component: AppErrorComponent },
            { path: AirAppRoutes.Auth.ACCESS, component: AppAccessdeniedComponent },
            { path: AirAppRoutes.Auth.NOT_FOUND, component: AppNotfoundComponent },

            {
                path: AirAppRoutes.DirectLink.DIRECT_LINK,
                component: DirectLinkShipmentTrackingDetailsComponent,
                canLoad: [NoAuthGuard],
            },
            {
                path: AirAppRoutes.DirectLink.EXTERNAL_API_TRACKING_DETAILS + ':encryptedText',
                canLoad: [NoAuthGuard],
                component: DirectLinkShipmentTrackingDetailsComponent,
            },
            {
                path: AirAppRoutes.DirectLink.LINK_NOT_FOUND,
                canLoad: [NoAuthGuard],
                component: DirectLinkComponent
            },

        ], {

            scrollPositionRestoration: 'enabled'
        })
    ],
    exports: [RouterModule],
})
export class AppRoutingModule { }
